<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="500"
      transition="dialog-bottom-transition"
      scrollable
      persistent
    >
      <v-card class="scroll-y" style="height: 375px">
        <v-card-title>
          <span class="text-h5">{{ $t("_menu.category") }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-bind:valid="valid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="8">
                  <v-text-field
                    style="margin-top: -9px"
                    ref="categoryName"
                    v-model="editedItem.name"
                    :label="$t('_menu.categoryName')"
                    :hint="$t('_label.addCategoryNameHint')"
                    :rules="[(v) => !!v || $t('_rules.categoryRules')]"
                    :prepend-inner-icon="editedItem.icon"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <vue2-iconifier
                    :toggle="toggleDialog"
                    @toggle="catchToggle"
                    @selectIcon="catchSelected"
                    :lang="language"
                  />
                  <v-btn color="primary" @click="toggleDialog = true"
                    ><v-icon left>add</v-icon
                    >{{ $t("_label.iconSelect") }}</v-btn
                  >
                </v-col>
                <!-- <v-col sm="4">
              <v-btn small rounded color="error" depressed>
                <v-icon left>add </v-icon>
                Select Icon
              </v-btn>
            </v-col> -->
                <!-- <v-col cols="12" sm="6">
              <v-text-field
                label="Icon"
                hint="Eklencek Icon"
                :rules="[(v) => !!v || this.$t("_rules.iconRules")]"
                :prepend-icon="selection"
              >
              </v-text-field>

              <vue2-iconifier @selectIcon="catchSelected" />
              <v-btn
                ><v-icon>{{ selection }}</v-icon></v-btn
              >
            </v-col> -->
              </v-row>

              <v-row class="mb-6">
                <v-checkbox
                  v-model="checkboxEnabled"
                  hide-details
                  :label="$t('_menu.subCategory')"
                  class="shrink mr-2 mt-0"
                ></v-checkbox>
              </v-row>
              <!-- <v-row> {{ this.value }} </v-row> -->
              <v-row>
                <treeselect
                  ref="tree"
                  :disabled="!checkboxEnabled"
                  v-model="editedItem.parentCategoryId"
                  :options.sync="items"
                  :show-count="true"
                  :normalizer="normalizer"
                  :max-height="250"
                  :placeholder="$t('_label.subCategoryPlaceholder')"
                />
              </v-row>
                <v-row><br></v-row>
              <v-row class = "visible-section" >
                <v-checkbox
                  v-model="editedItem.isVisible"
                  :disabled = "newItemStatus"
                  hide-details
                  :label="$t('actions.showCategory')"
                  class="shrink mr-2 mt-0"
                ></v-checkbox>
              </v-row>
              <!-- <v-row>
            <v-autocomplete
              :disabled="!enabled"
              :items="items"
              label="Kategori Grupları"
              :rules="[(v) => !!v || this.$t("_rules.categoryGroupRules")]"
            >
            </v-autocomplete>
          </v-row>
          <v-row>
            <v-combobox v-model="value" :items="items" label="Tree">
              <v-treeview
                :items="items"
                caption-field="name"
                children-field="children"
              ></v-treeview>
            </v-combobox>
          </v-row> -->
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="save()"
            v-bind:valid="valid"
          >
            {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: { Treeselect },
  props: {
    dialog: Boolean,
    editedItem: Object,
    editedIndex: Number,
    checkboxEnabled: Boolean,
    newItemStatus:Boolean
  },
  computed: {
    myBoolComputed() {
      return editedItem.parentCategoryId ? true : false;
    },
  },
  mounted() {
    console.warn("createddd",this.editedItem.parentCategoryId,this.enabled)
    if(this.editedItem.parentCategoryId != null){
      this.enabled = true;
    }
  },
  data: () => ({
    selection: "",
    toggleDialog: false,
    categoryRules: [(v) => !!v || $t("_rules.categoryRules")],
    categoryGroupRules: [(v) => !!v || this.$t("_rules.categoryGroupRules")],
    iconRules: [(v) => !!v || this.$t("_rules.iconRules")],
    categoryName: null,
    enabled: false,
    normalizer(node) {
      return {
        label: node.name,
      };
    },
    snackbar: false,
    snackColor: "",
    snackText: "",
    timeout: 3000,
    x: "",
    y: "",
    mode: "",
    valid: false,
  }),
  computed: {
    ...mapGetters({ items: "category_tree/items" }),
    ...mapGetters({ language: "app/language" }),
  },
  methods: {
    ...mapActions(["category_tree/getItems"]),

    async save() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        if (this.editedIndex == -1) {
          // if (this.enabled) {
          try {
            await this.$store.dispatch("category/addCategory", {
              name: this.editedItem.name,
              icon: this.editedItem.icon,
              categoryGroupId: this.editedItem.parentCategoryId,
              isVisible: this.editedItem.isVisible + 0,
            });
            this.dialog = false;
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Kaydetme Başarılı!";
            this.x = "center";
            this.y = "bottom";
            this.timeout = 3000;
          } catch (error) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Kaydetme Başarısız!";
            // console.error(e);
          }
          // }
          // else {
          //   try {
          //     await this.$store.dispatch("category/addCategory", {
          //       name: this.editedItem.name,
          //       icon: this.editedItem.icon,
          //       categoryGroupId: this.editedItem.parentCategoryId,
          //     });
          //     this.dialog = false;
          //     this.snackbar = true;
          //     this.snackColor = "success";
          //     this.snackText = "Kaydetme Başarılı!";
          //     this.x = "center";
          //     this.y = "bottom";
          //   } catch (error) {
          //     this.snackbar = true;
          //     this.snackColor = "error";
          //     this.snackText = "Kaydetme Başarısız!";
          //     console.error(e);
          //   }
          // }
          //this.$emit("confirmed", this.editedItem);
          this.close();
          this.getNavMenu();
        } else {
          console.log("editedcategory", this.editedItem);
          try {
            await this.$store.dispatch("category/updateCategory", {
              name: this.editedItem.name,
              icon: this.editedItem.icon,
              categoryId: this.editedItem.id,
              parentCategoryId: this.editedItem.parentCategoryId,
              isVisible: this.editedItem.isVisible + 0,
            });
            this.dialog = false;
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Kaydetme Başarılı!";
            this.x = "center";
            this.y = "bottom";
            this.timeout = 3000;
          } catch (error) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Kaydetme Başarısız!";
            // console.error(e);
          }
          this.close();

          this.getNavMenu();
        }
      }
    },
    async getNavMenu() {
      await this.$store.dispatch("category_tree/getItems");
    },
    catchSelected(selectedIcon) {
      this.selection = selectedIcon; // selection is a variable defined in parent component.
      this.editedItem.icon = selectedIcon;
    },
    catchToggle(event) {
      this.toggleDialog = event; // toggleDialog is a variable defined in parent component.
    },

    close() {
      this.dialog = false;
      this.editedItem.icon = null;
      this.$refs.form.reset();
      this.editedItem.isVisible = 1;
      this.$emit("cancelled");
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
  watch: {
    checkboxEnabled: function () {
      if (this.checkboxEnabled == false) {
        this.editedItem.parentCategoryId = null;
      }
    },
    dialog(val) {
      this.$refs.form.resetValidation();
      val || this.close();
    },
    options: {
      handler() {
        this.refresh();
      },
      deep: true,
    },
    items: function () {
      //this.getNavMenu();
    },
  },
};
</script>